import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { Observable } from 'rxjs';
import { filter, finalize, map, switchMap, take, tap } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso } from 'src/app/model/aviso.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { MonitoracaoService } from '../../shared/services/monitoracao.service';
import { AvisoService } from '../aviso/aviso.service';
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import Utils from 'src/app/shared/fgi-utils';

@Component({
    selector: 'app-home',
    templateUrl: 'termos.component.html',
    styleUrls: ['termos.component.scss'],
    standalone: false
})
export class TermosComponent implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private cnpjAgente: string = null;
    versao = '';
    dataCorrenteStr = '';
    avisos$: Observable<Aviso[]>;
    usuarioSemPermissao$: Observable<Boolean>;

    constructor(
        private modalidadeService: ModalidadeService,
        private monitoracaoService: MonitoracaoService,
        private permissaoService: PermissaoService,
        private usuarioService: BnUsuarioService,
        private avisoService: AvisoService,
        private fileUtils: FileUtilsService,
        private activatedRoute: ActivatedRoute,
        private loadingService: BnLoadingService,
        private dataSistemaService: DataSistemaService) {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    ngOnInit() {
        var link = 'assets/pdfs/termos-de-uso-fundos-garantidores-e-fg-energia.pdf';
	    window.open(link,"download");
    }

    public obterModalidade() {
        return this.modalidadeService.modalidadeTitulo$;
    }

    get ehUsuarioAgente(): boolean {
        return !!this.cnpjAgente;
    }

    private buscaCnpjCasoSejaUmAgenteFinanceiro(usuario): string {
        this.loadingService.bloqueiaTela();
        return this.permissaoService.getPermissoesUsuarioAutenticado().pipe(
            take(1),
            tap(() => this.loadingService.liberaTela()),
            filter(prm => prm && prm[ROLE_AGENTE_CONSULTA]),
            map(() => {
                this.cnpjAgente = usuario && usuario.cnpj; // remover quando tirar o cnpjagente
                return this.cnpjAgente;
            }),
        );
    }

    getVersao() {
        this.monitoracaoService.getVersao().subscribe(respostaVersao => this.versao = respostaVersao.versao);
    }

    getDataCorrente() {
      this.dataSistemaService.getDataCorrenteStr().subscribe(
          dataCorrente => this.dataCorrenteStr = dataCorrente ? (" - " + dataCorrente) : '');
    }

    nomeAgente(id: number) {
        return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
    }

    exportarAnexo(aviso: Aviso) {
        this.avisoService.getAnexo(aviso.id).subscribe((conteudo) => {
            this.fileUtils.exportarArquivo('Aviso_' + aviso.id + '.csv', conteudo, FileUtilsService.TEXT_CSV);
        });
    }

}
